import { BigNumber } from 'bignumber.js';

export class LoanModel {
  id: string;
  amount: number;

  constructor(data) {
    this.id = data.id;
    this.amount = data.amount;
  }

  get amountFormatted() {
    return new BigNumber(this.amount).toFormat(2);
  }
}

export class WalletModel {
  token: string;
  balance: string;

  constructor(data) {
    this.token = data.token;
    this.balance = data.balance;
  }

  // get formatBalance(decimal = 2) {
  //   return new BigNumber(this.balance).toFormat(decimal)
  // }
}
